import { render, staticRenderFns } from "./NjwxView.vue?vue&type=template&id=419e404f&scoped=true&"
import script from "./NjwxView.vue?vue&type=script&lang=js&"
export * from "./NjwxView.vue?vue&type=script&lang=js&"
import style0 from "./NjwxView.vue?vue&type=style&index=0&id=419e404f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419e404f",
  null
  
)

export default component.exports